export enum OrderStatus {
  planned = "planned",
  unassigned = "new",
  inProgress = "in-progress",
  cancelled = "cancelled",
  completed = "completed",
  tonu = "tonu",
  waitingTonu = "wait-tonu",
  noTonu = "no-tonu",
}

export type OrderStatusMapItem = {
  id: OrderStatus;
  name: string;
  forCancellation?: boolean;
  forEdit?: boolean;
};
export type OrderStopStatusMapItem = { id: OrderStopStatus; name: string };
export type OrderStopStateMapItem = { id: OrderStopState; name: string };
export type OrderStopTypeMapItem = { id: OrderStopType; name: string };
export type OrderStopTimeTypeMapItem = { id: OrderStopTimeType; name: string };
export type OrderFreightTypeMapItem = { id: OrderFreightType; name: string };

export const OrderStatusMap: OrderStatusMapItem[] = [
  {
    id: OrderStatus.planned,
    name: "Planned",
  },
  {
    id: OrderStatus.completed,
    name: "Completed",
  },
  {
    id: OrderStatus.waitingTonu,
    name: "Waiting for TONU",
    forCancellation: true,
    forEdit: true,
  },
  {
    id: OrderStatus.unassigned,
    name: "Unassigned",
    forEdit: true,
  },
  {
    id: OrderStatus.tonu,
    name: "TONU",
    forCancellation: true,
    forEdit: true,
  },
  {
    id: OrderStatus.cancelled,
    name: "Cancelled",
    forCancellation: true,
    forEdit: true,
  },
  {
    id: OrderStatus.inProgress,
    name: "In progress",
  },
  {
    id: OrderStatus.noTonu,
    name: "No TONU",
    forEdit: true,
    forCancellation: true,
  },
];

export const OrderEditStatusMap: OrderStatusMapItem[] = OrderStatusMap.filter((s) => s?.forEdit);

export const OrderCancellationStatusMap: OrderStatusMapItem[] = OrderStatusMap.filter((s) => s.forCancellation);

export enum OrderStopTimeType {
  fcfs = "f",
  asap = "as",
  direct = "d",
  appointment = "ap",
}

export const OrderStopTimeTypeMap: OrderStopTimeTypeMapItem[] = [
  {
    id: OrderStopTimeType.fcfs,
    name: "FCFS",
  },
  {
    id: OrderStopTimeType.asap,
    name: "ASAP",
  },
  {
    id: OrderStopTimeType.direct,
    name: "Direct",
  },
  {
    id: OrderStopTimeType.appointment,
    name: "Appointment",
  },
];

export enum OrderStopType {
  pickup = "p",
  delivery = "d",
  reload = "r",
}

export enum OrderStopTypeOption {
  pickup = "p",
  delivery = "d",
}

export const OrderStopTypeMap: Record<OrderStopType, string> = {
  [OrderStopType.pickup]: "Pick up",
  [OrderStopType.delivery]: "Delivery",
  [OrderStopType.reload]: "Reload",
};

export const OrderStopShortTypeMap: Record<OrderStopType, string> = {
  [OrderStopType.pickup]: "PU",
  [OrderStopType.delivery]: "DEL",
  [OrderStopType.reload]: "REL",
};

export const OrderStopTypesOptions = [
  {
    id: OrderStopTypeOption.pickup,
    name: "On route to PU",
  },
  {
    id: OrderStopTypeOption.delivery,
    name: "On route to DEL",
  },
];

export enum OrderFreightType {
  pallets = "pl",
  pieces = "pc",
}

export const OrderFreightTypeObject = {
  pl: "pallets",
  pc: "pieces",
};

export const OrderFreightTypeMap: OrderFreightTypeMapItem[] = [
  {
    id: OrderFreightType.pallets,
    name: "Pallets",
  },
  {
    id: OrderFreightType.pieces,
    name: "Pieces",
  },
];

export enum OrderStopStatus {
  notStarted = "new",
  inProgress = "in-progress",
  partiallyCompleted = "part-completed",
  completed = "completed",
}

export const OrderStopStatusMap: OrderStopStatusMapItem[] = [
  {
    id: OrderStopStatus.notStarted,
    name: "Not started",
  },
  {
    id: OrderStopStatus.inProgress,
    name: "In progress",
  },
  {
    id: OrderStopStatus.partiallyCompleted,
    name: "Partially completed",
  },
  {
    id: OrderStopStatus.completed,
    name: "Completed",
  },
];

export enum OrderStopState {
  normal = "normal",
  new = "new",
  updated = "updated",
}

export const OrderStopStateMap: OrderStopStateMapItem[] = [
  {
    id: OrderStopState.normal,
    name: "Normal",
  },
  {
    id: OrderStopState.new,
    name: "New stop",
  },
  {
    id: OrderStopState.updated,
    name: "Updated",
  },
];

export enum OrderFreightState {
  normal = "normal",
  new = "new",
  updated = "updated",
}
